module.exports = __webpack_public_path__ + "static/media/marcasAberturas.1e30d48b.jpg";